export function getCmVehicleStartEnd(booking) {
  if (!booking || booking.status === 'cancelled')
    return { start: null, end: null, timeKind: 'planned' }

  const actual = booking.actual || {}
  const actualStart = actual.nearestLocationStartDateTime
  const actualEnd = actual.nearestLocationFinishDateTime
  if (actualStart && actualEnd)
    return { start: actualStart, end: actualEnd, timeKind: 'actual' }

  const plannedStart = actual.plannedStartDateTime || booking.start_datetime
  const plannedEnd = actual.plannedFinishDateTime || booking.finish_datetime
  if (plannedStart && plannedEnd)
    return { start: plannedStart, end: plannedEnd, timeKind: 'planned' }

  return { start: null, end: null, timeKind: 'planned' }
}

export function getTbnVehicleStartEnd(booking) {
  if (!booking || booking.status === 'cancelled')
    return { start: null, end: null, timeKind: 'planned' }

  const actual = booking.actual || {}
  const actualStart = actual.actualStartLocationTime
  const actualEnd = actual.actualFinishLocationTime
  if (actualStart && actualEnd)
    return { start: actualStart, end: actualEnd, timeKind: 'actual' }

  const plannedStart = booking.start_datetime
  const plannedEnd = booking.finish_datetime
  if (plannedStart && plannedEnd)
    return { start: plannedStart, end: plannedEnd, timeKind: 'planned' }

  return { start: null, end: null, timeKind: 'planned' }
}

import { excludeSkippedUnlessSelected } from '@/helpers/actuals_status_filter'

export function filterVehicleActualsByStatus(items, selectedStatus) {
  if (!items)
    return []
  const visible = excludeSkippedUnlessSelected(items, selectedStatus)
  if (selectedStatus == null)
    return visible
  if (selectedStatus === 'vehicle_overlap')
    return visible.filter(item => item.vehicle_overlap)
  return visible.filter(item => item.status === selectedStatus)
}
